import { ChangeDetectionStrategy, Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LogModal } from '@app/core/states/events-tracking.actions';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';

interface DataInput {
  widgetCode: string;
  warning: string;
  name?: string;
}

@Component({
  selector: 'rk-widget-code-modal',
  templateUrl: './widget-code-modal.component.html',
  styleUrls: ['./widget-code-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetCodeModalComponent {
  constructor(
    public readonly dialogRef: MatDialogRef<WidgetCodeModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DataInput,
  ) {
    this.logModal(data.name);
  }

  close() {
    this.dialogRef.close();
  }

  @Dispatch()
  logModal = (name: string) => new LogModal({ name, origin: 'Share' });
}
